import styled from "styled-components";
import { useContext, useState } from "react";
import {
  addUserToOktaGroup,
  reformatHotTopicsDatabase,
  deleteCollection,
  moveCollection,
  saveOrgTree,
  getUserDatabase,
} from "../../Firebase";
import { updateOrgTreeWithNewUserRoles } from "../../Helpers/OrgTreeFunctions";
import { OrgTreeContext } from "../../Contexts/OrgTreeContext";

const RowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 5px 0;
  margin: 0 30px;
  .button {
    width: 100px;
    margin: 0 5px;
  }
`;

export default function DataCleanup(props: Props) {
  const orgTree = useContext(OrgTreeContext);

  function syncAllUserRolesInOrgTree() {
    if (!orgTree) {
      console.log("Error, no orgTree Data");
      return;
    }
    let newOrgTree = orgTree;
    getUserDatabase().then((users) => {
      if (!users) {
        console.log("Error, no users Data");
        return;
      }
      console.log("users", users)
      users.forEach((user) => {
        newOrgTree = updateOrgTreeWithNewUserRoles(newOrgTree, user);

      });
    }).then(() => {
      saveOrgTree(newOrgTree);
      console.log("Org Tree Updated", newOrgTree);
    });

  
  }

  return (
    <RowWrapper>
      <h2>Sync all user roles in org tree</h2>
      <p>
        Checks all the users in the data base and checks that they all are in
        each of their roles are in the org tree and if they are not it adds them
        to a new org tree and uploads the new org tree to the data base
      </p>

      <button onClick={syncAllUserRolesInOrgTree}>Sync</button>
    </RowWrapper>
  );
}

interface Props {}
